import { z } from 'zod';

export const REASON_MAX = 1000;

/** Body of POST /applications/:id/reject; `notify` emails the reason to the applicant. */
export const rejectSchema = z.object({
  reason: z
    .string()
    .trim()
    .min(1, { error: 'applications:validation.reasonRequired' })
    .max(REASON_MAX, { error: 'applications:validation.reasonMax' }),
  notify: z.boolean(),
});

export type RejectValues = z.infer<typeof rejectSchema>;
